import { type IconProps } from '@atlaskit/icon';
import { Inline, Stack, Text, Box, xcss } from '@atlaskit/primitives';
import React, { type FunctionComponent } from 'react';

const iconStyles = xcss({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0
});

const menuIconStyles = xcss({
  paddingTop: 'space.025'
});

const valueOptionStyles = xcss({
  flexShrink: 1,
  minWidth: '0',
  maxWidth: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
});

const valueNameStyles = xcss({
  display: 'block',
  flexShrink: 1,
  minWidth: '0',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

export interface ParentPickerOptionProps {
  IconComponent: React.ComponentType<IconProps>;
  valueName: string;
  spaceName: string;
  context: 'menu' | 'value';
  isSelected?: boolean;
}

const ParentPickerOption: FunctionComponent<ParentPickerOptionProps> = ({
  IconComponent,
  valueName,
  spaceName,
  context,
  isSelected
}) => {
  if (context === 'value') {
    return (
      <Inline space="space.100" alignBlock="center" xcss={valueOptionStyles}>
        <Box xcss={iconStyles}>
          <IconComponent label="" size="medium" />
        </Box>
        <Box as="span" xcss={valueNameStyles}>
          {valueName}
        </Box>
      </Inline>
    );
  }

  return (
    <Inline space="space.100" alignBlock="start">
      <Box xcss={[iconStyles, context === 'menu' && menuIconStyles]}>
        <IconComponent label="" size="medium" />
      </Box>
      <Stack space="space.025">
        <Text color="inherit">{valueName}</Text>
        {context === 'menu' && (
          <Text color={isSelected ? 'inherit' : 'color.text.subtlest'}>{spaceName}</Text>
        )}
      </Stack>
    </Inline>
  );
};

export default ParentPickerOption;
